export default __webpack_public_path__ + "static/media/phonegirl@2x.c49c683e.png";